export default class ServiceRequestError extends Error {

    public exceptionName?: string;
    public fieldName?: string;
    public statusCode?: number;

    constructor(message: string) {
        super(message);
    }   

}